import { Injectable } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { CommonService } from '../common.service';
import { appSettings, errorMessages } from '../../settings';
import * as moment from 'moment';
import { SignalRConnection, BroadcastEventListener, ConnectionStatus, ConnectionStatuses } from 'ng2-signalr';
import { UserPreference } from '../../models/UserPreference';
import { WidgethelperService } from '../widgethelper.service';

@Injectable()
export class WavepulltimemonitorService {

  private hub: SignalRConnection;

  constructor(private _dashboardService: DashboardService,
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService) { }

  chartOptions() {
    return {
      legend: {
        data: ["orders", "units"],
        textStyle: {
          color: "#e6e6e6"
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        formatter: this._widgetHelper.WavepulltimeTooltip
      },
      xAxis: {
        boundaryGap: true,
        axisTick: {
          show: true,
          alignWithLabel: true
        },
        data: [], // category,
        offset: 10,
        axisLine: {
          lineStyle: {
            color: "#ccc"
          }
        },
        axisLabel: {
          interval: 0,
          color: '#ccc',
          length: '100%',
          rotate: 25,
          formatter: function (value) {
            return value.split(' ').join('');
          }
        }
      },
      grid: {
        bottom: '150',
        left: '10%',
        right: '2%',
        width: "85%"
      },
      yAxis: {
        splitLine: { show: false },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#575757"
          }
        },
        axisLabel: {
          show: false,
          formatter: this._widgetHelper.WavepulltimeAxisLabel
        }
      },
      series: [
        {
          name: "Trend",
          type: "line",
          smooth: true,
          showAllSymbol: true,
          symbol: "circle",
          itemStyle: {
            normal: {
              color: "#77007E"
            }
          },
          symbolSize: 40,
          symbolPosition: "start",
          lineStyle: {
            normal: {
              opacity: 1
            }
          },
          label: {
            normal: {
              formatter: this._widgetHelper.WavepulltimeSeriesLabel,
              position: "inside",
              show: true,
              textStyle: {
                color: "#fff",
                decoration: "none",
                fontWeight: "200",
                fontFamily: "Verdana, sans-serif",
                fontSize: 9
              }
            }
          },
          data: [] // lineData
        },
        {
          name: "Shipped Orders",
          type: "bar",
          barWidth: 10,
          itemStyle: {},
          data: [] //barData
        },
        {
          name: "Pending Orders",
          type: "bar",
          barGap: "-100%",
          barWidth: 10,
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "top",
                offset: [0, -30],
                // formatter: "[ " + "{c}" + " ]",
                formatter: this._widgetHelper.WavepulltimeItemStyle,
                textStyle: {
                  color: "#ccc",
                  fontWeight: "normal"
                }
              }
            }
          },
          z: -12,
          data: [] // lineData
        },
        {
          name: "dotted",
          type: "pictorialBar",
          symbol: "rect",
          itemStyle: {
            normal: {
              color: "#000"
            }
          },
          symbolRepeat: true,
          symbolSize: [12, 4],
          symbolMargin: 1,
          z: -10,
          data: [] // lineData
        }
      ]
    };
  }

  init(widget: any) {
    console.log('Wave Pull Time Monitor')
    widget.dataLoaded = false;
    let currentDateTime = moment().toDate().getTime();
    widget.Title = 'Wave Pull Time Monitor';
    widget.initcreationtime = currentDateTime;
    widget.widgetcreationtime = currentDateTime;
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.startWave = 0;
    widget.endWave = 10;
    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        widget.ConnectionId = widget.hub.id;
        let userPref: UserPreference = this._commonService.getUserPreference();
        widget.hub.listenFor('broadcastPutWallMonitor')
          .subscribe((result: any) => {
            console.log('broadcastPutWallMonitor', result);
            //need to format this 
            let resultwid;
            let resultcreationtime;
            let tmpMonitorType;
            let lastUpdatedTime;

            console.log("broadcastPutWallMonitor", result);
            if (result.length > 0) {
              console.log(result[0].IsNoDataFound);
              widget.IfNoDataFound = result[0].IsNoDataFound;
              resultwid = result[0].widgetid;
              resultcreationtime = result[0].widgetcreationtime;
              lastUpdatedTime = result[0].LastUpdateTime;
            }
            if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
              widget.dataLoaded = false;
              widget.chartOptions = this.chartOptions();
              let tmpline = 0;
              let category_tmp = [];
              let lineData_tmp = [];
              let lineData_tmp2 = [];
              let barData_tmp = [];
              let lineData_tmp3 = [];
              let hasData: boolean = false;

              if (result.length <= widget.startWave) {
                widget.startWave = (result.length - 10) > 0 ? (result.length - 10) : 0
              }
              else if (widget.startWave < 0) {
                widget.startWave = 0;
              }

              if (result.length <= widget.endWave) {
                widget.endWave = result.length;
              }
              else {
                widget.endWave = widget.startWave + 10;
              }
              widget.waveCount = result.length;

              for (let i = widget.startWave; i < result.length; i++) {
                if (!widget.IfNoDataFound) {
                  hasData = true;
                  if (i == widget.endWave) {
                    break;
                  }
                  tmpline = 0;
                  let objitemStyleRed =
                    "normal:  { color: { type: 'linear',x:0,y:0,x2:0,y2:1, colorStops:[ {offset: 0, color: 'rgba(255,0,0,0.2)'}, {offset: 0.2, color: 'rgba(255,0,0,0.4)'}, {offset: 1, color: 'rgba(255,0,0,0.8)'} ] } } ";
                  let objitemStyleGreen =
                    "normal:  { color: { type: 'linear',x:0,y:0,x2:0,y2:1, colorStops:[ {offset: 0, color: 'rgba(0,255,0,0.2)'}, {offset: 0.2, color: 'rgba(0,255,0,0.4)'}, {offset: 1, color: 'rgba(0,255,0,0.8)'} ] } } ";
                  let objitemStyleYellow =
                    "normal:  { color: { type: 'linear',x:0,y:0,x2:0,y2:1, colorStops:[ {offset: 0, color: 'rgba(255,255,0,0.2)'}, {offset: 0.2, color: 'rgba(255,255,0,0.4)'}, {offset: 1, color: 'rgba(255,255,0,0.8)'} ] } } ";

                  //const titlearray = result[i].WaveTitle;//.split(" ");
                  let tmptitle = result[i].WaveTitle ? result[i].WaveTitle + '\n' + result[i].WaveCode : "";
                  // console.log(titlearray);
                  // for (const x of titlearray) {
                  //     console.log(x);
                  //     if(tmptitle!=' '){
                  //       if(tmptitle.length > 15 ){
                  //       tmptitle = tmptitle + '\n' + x;
                  //       }else {
                  //         tmptitle = tmptitle + ' ' + x;
                  //       }
                  //     }
                  //     else{
                  //       tmptitle = x;
                  //     }
                  // }

                  //   for (let k=0; k< titlearray.length; k++){
                  //    // if(titlearray[k]!=' '){
                  //       if(k!=0)
                  //       tmptitle = tmptitle + '\n' + tmptitle;
                  //       else    
                  //       tmptitle = titlearray[k];
                  //  // }
                  //   }

                  let xaxisvalue = tmptitle;// result[i].WaveTitle ; // + '\n' + result[i].Carrier;

                  tmpline = result[i].StoreCount; //result[i].PendingOrders + result[i].ShippedOrders;

                  category_tmp.push(xaxisvalue);
                  //console.log(result[i].PullTimePerformaceRate);
                  let perShipped = (result[i].CompletedStoreCount / result[i].StoreCount * 100).toFixed(1);
                  let loadingStoresCount = Number.parseFloat(result[i].StoreCount) - Number.parseFloat(result[i].CompletedStoreCount);
                  let shippedStoresCount = Number.parseFloat(result[i].CompletedStoreCount);
                  let percentageloading = (loadingStoresCount / result[i].StoreCount * 100).toFixed(1);

                  lineData_tmp2.push({
                    value: tmpline,
                    name: perShipped + "%" + '\n' + ' Loading : ' + percentageloading + "%" + ' (' + loadingStoresCount + ')  ',
                    itemStyle: {
                      normal: {
                        color: {
                          type: "linear",
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [
                            { offset: 0, color: "rgba(255,0,0,0.2)" },
                            { offset: 0.2, color: "rgba(255,0,0,0.4)" },
                            { offset: 1, color: "rgba(255,0,0,0.8)" }
                          ]
                        }
                      }
                    }
                  });

                  barData_tmp.push({
                    value: result[i].CompletedStoreCount,
                    name: result[i].CompletedStoreCount,
                    itemStyle: { normal: { color: "red" } }
                  });

                  lineData_tmp3.push({
                    value: tmpline,
                    name: tmpline,
                    itemStyle: { objitemStyleRed }
                  });

                  lineData_tmp.push({
                    value: tmpline,
                    name: tmpline,
                    Pending: result[i].RemainingStoreCount
                  });
                }
              }

              if (!hasData) {
                widget.errorMessage = errorMessages.noWidgetData;
              }
              else {
                widget.errorMessage = null;
              }
              widget.chartOptions.xAxis.data = category_tmp;
              widget.chartOptions.series[0].data = lineData_tmp; //lineData;
              widget.chartOptions.series[1].data = barData_tmp;
              widget.chartOptions.series[2].data = lineData_tmp2; //barData;
              widget.chartOptions.series[3].data = lineData_tmp3;
              this._commonService.lastUpdatedTime = lastUpdatedTime;
            }
            //console.log(result)  ;
            widget.dataLoaded = true;
          }
            , err => {
              console.log('listenFor broadcastPutWallMonitor error', err);
            }
          );

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVEPULLTIMESMONITOR";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;

        widgetData.ConnectionId = widget.hub.id;
        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })

      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  reload(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.chartOptions = this.chartOptions();

    widget.hub.start()
      .then(() => {
        console.log('Connection started!');
        let widgetSettingParam = {
          WidgetType: "WavePullTimesMonitor",
          WidgetId: widget.widgetId,
          CreatedTime: widget.widgetcreationtime,
          ConnectionId: widget.ConnectionId
        };
        //console.log(widgetSettingParam);
        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) {
          }
        });

        let oldwidgettime = widget.widgetcreationtime;
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        let userPref: UserPreference = this._commonService.getUserPreference();

        let widgetData: any = {};
        widgetData = this._commonService.deepClone(widget.widgetsettings);
        widgetData.WidgetType = "WAVEPULLTIMESMONITOR";
        widgetData.CreatedTime = widget.widgetcreationtime;
        widgetData.CustomerId = userPref.CustomerId;
        widgetData.Facility = userPref.FacilityId;
        widgetData.LastUpdate = "31-Jan-2017";
        widgetData.WidgetId = widget.widgetId;
        widgetData.ConnectionId = widget.hub.id;
        widgetData.OldWidgettime = oldwidgettime;

        widget.hub.invoke('GetWidgetData', widgetData)
          .then(data => {
            //console.log('GetWidgetData', data);
          })
          .catch(err => {
            console.log('Error GetWidgetData', err);
          })
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

  remove(widget: any) {
    if (!widget.hub) {
      widget.hub = this._dashboardService.startConnection();
    }

    widget.hub.start()
      .then(() => {
        let oldwidgettime = widget.widgetcreationtime;
        let widgetSettingParam = {
          WidgetType: "WavePullTimesMonitor",
          WidgetId: widget.widgetId,
          CreatedTime: oldwidgettime,
          ConnectionId: widget.ConnectionId
        };
        let currentDateTime = moment().toDate().getTime();
        widget.widgetcreationtime = currentDateTime;

        widget.hub.invoke('RemoveWidget', widgetSettingParam).then((isWidgetConnected: any) => {
          if (isWidgetConnected) { }
          console.log('deleteWidget WavePullTimesMonitor RemoveWidget');
        });
      })
      .catch(err => {
        console.log('Error while establishing connection', err);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/widgets/wavepulltimemonitor.service.ts